export default __webpack_public_path__ + "static/media/mr-bay.ef731801.jpg";